import React from 'react';
import {Route} from 'react-router';
import {Grid, Row, Col, MainContainer} from '@sketchpixy/rubix';

import Sidebar from './common/sidebar';
import Header from './common/header';
import Footer from './common/footer';
import Homepage from './routes/Homepage';
import Login from './routes/Login';
import Unauthorized from './routes/Unauthorized';
import Dashboard from './routes/Dashboard';
import PreSubscription from './routes/product/PreSubscription';
import PatientStatus from './routes/patient/Status';
import Payment from './routes/payment/Payment';
import PaymentList from './routes/payment-list/Payments';
import PatientList from './routes/patient/List';
import PatientDetail from './routes/patient/Detail';
import UserList from './routes/user/List';
import CpMapping from './routes/cp-mapping/CpMapping';
import Upload from './routes/asset/Upload';
import Admins from './routes/admin/Admins';
import AdminEdit from './routes/admin/AdminEdit';
import Roles from './routes/permission/Role/Roles';
import EditRole from './routes/permission/Role/components/EditRole';

import RoleGroups from './routes/permission/RoleGroups/RoleGroups';
import EditRoleGroup from './routes/permission/RoleGroups/RoleGroup/EditRoleGroup';
import ReleaseMgnt from './routes/ReleaseMgnt/ReleaseMgnt';
import ReleaseDetail from './routes/ReleaseMgnt/ReleaseDetail';
import MultilingualMgnt from './routes/MultilingualMgnt/MultilingualMgnt';
import MultilingualDetail from './routes/MultilingualMgnt/MultilingualDetail';
import {routeUrl} from './routes/routeUrl';
import Calculator from './routes/calculator/Calculator';

class App extends React.Component {
  render() {
    return (
        <MainContainer {...this.props}>
          <Sidebar />
          <Header />
          <div id='body'>
            <Grid>
              <Row>
                <Col xs={12}>
                  {this.props.children}
                </Col>
              </Row>
            </Grid>
          </div>
          <Footer />
        </MainContainer>
    );
  }
}

/**
 * Includes Sidebar, Header and Footer.
 */
const routes = (
    <Route component={App}>
      <Route path={routeUrl.dashboard} component={Dashboard} />

      <Route path={routeUrl.rapaelHomeSubscriptionStatus} component={PatientStatus} />
      <Route path={routeUrl.preSubscriptions} component={PreSubscription} />
      <Route path={routeUrl.rapaelHomePayment} component={Payment} />
      <Route path={routeUrl.rapaelHomePaymentList} component={PaymentList} />
      <Route path={routeUrl.rapaelHomeCalculator} component={Calculator} />
      <Route path={routeUrl.rapaelHomePatientsList} component={PatientList} />
      <Route path={`${routeUrl.rapaelHomePatientsDetail}/:patientId`} component={PatientDetail} />
      <Route path={routeUrl.rapaelHomeUserList} component={UserList} />
      <Route path={routeUrl.rapaelHomeCpMapping} component={CpMapping} />
      <Route path={`${routeUrl.assetUpload}/:serviceType`} component={Upload} />
      <Route path={`${routeUrl.assetUpload}/:serviceType/:versionCode`} component={Upload} />
      <Route path={routeUrl.adminUsers} component={Admins} />
      <Route path={`${routeUrl.adminUserEdit}/:adminUserId`} component={AdminEdit} />

      <Route path={routeUrl.adminRoles} component={Roles} />
      <Route
          path={routeUrl.adminRoleCreate}
          component={(props) => (
              <EditRole {...props}/>
          )}
      />
      <Route
          path={`${routeUrl.adminRoleEdit}/:roleId`}
          component={(props) => (
              <EditRole {...props}/>
          )}
      />
      <Route path={routeUrl.adminRoleGroups} component={RoleGroups} />
      <Route
          path={routeUrl.adminRoleGroupCreate}
          component={(props) => (
              <EditRoleGroup {...props} editMode={false} />
          )}
      />
      <Route
          path={`${routeUrl.adminRoleGroupEdit}/:roleGroupId`}
          component={(props) => (
              <EditRoleGroup {...props} editMode={true} />
          )}
      />
      <Route path={routeUrl.multilingualMgnt} component={MultilingualMgnt} />
        <Route path={`${routeUrl.multilingualDetail}/:messageCodeId`} component={MultilingualDetail} />
        <Route path={`${routeUrl.multilingualDetail}`} component={MultilingualDetail} />
      <Route path={routeUrl.releaseMgnt} component={ReleaseMgnt} />
        <Route path={`${routeUrl.releaseDetail}/:rapaelClientId`} component={ReleaseDetail} />
        <Route path={`${routeUrl.releaseDetail}`} component={ReleaseDetail} />
    </Route>
);

/**
 * No Sidebar, Header or Footer. Only the Body is rendered.
 */
const basicRoutes = (
    <Route>
      <Route path={routeUrl.login} component={Login} />
      <Route path={routeUrl.unAuth} component={Unauthorized} />
    </Route>
);

const combinedRoutes = (
    <Route>
      <Route>
        {routes}
      </Route>
      <Route>
        {basicRoutes}
      </Route>
    </Route>
);

export default (
    <Route>
      <Route path='/' component={Homepage} />
      {combinedRoutes}
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js